import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Button, Col, Row} from 'react-bootstrap';
import {createAccountUrl, logout, isAuthenticated} from '../../../auth';
import LanguageSwitcher from '../../../i18n/LanguageSwitcher';

/**
 * Header-Element für die Seiten unter "Mein Bereich"/"my area"
 *
 * @constructor
 */
const Header: React.FC = () => (
    <header className='my-area-header'>
        <Row>
            <Col sm={6}>
                <h2>Leipziger Messe Kongressverwaltung</h2>
            </Col>
            <Col sm={6} className="meta-navigation">
                <Button variant="link">
                    <i className="fa fa-external-link"/>&nbsp;
                    <a href={createAccountUrl()}>
                        <FormattedMessage id="header.link.account"/>
                    </a>
                </Button>
                {isAuthenticated() && <Button variant="link" onClick={logout}>
                    <i className="fa fa-sign-out"/>&nbsp;
                    <FormattedMessage id="header.link.logout"/>
                </Button>}
                <Button variant="link">
                    <i className="fa fa-globe"/>&nbsp;
                    <LanguageSwitcher/>
                </Button>
            </Col>
        </Row>
    </header>
);

export default Header;
